import React, { useState } from "react";
import { PrimaryButton } from "../../common/common.style";
import { CardSelected } from "../../../type";
import { Box, FlexBox } from "../../primitives";
import { ModalChooseStrategy } from "../../ModalChooseStrategy/ModalChooseStrategy";
import { SelectDeselectCards } from "../../UploadCardsPageComponents/Header/SelectDeselectCards";
import { ImportExportCsv } from "../../UploadCardsPageComponents/Header/ImportExportCsv";
import { selectGame } from "../../../store/slices/global";
import { useSelector } from "react-redux";

interface HeaderProps {
  isCardsBoardEmpty: boolean;
  setCardsBoard: React.Dispatch<React.SetStateAction<CardSelected[]>>;
  cardsBoard: CardSelected[];
  cardsBoardCanDoOpeation: CardSelected[];
  hasEditedCards?: boolean;
  setIsOpenModalPublishChange?: (arg1: boolean) => void;
  cardsBoardFiltered: CardSelected[];
  cardsClicked: string[];
  setCardsClicked: (arg1: string[]) => void;
}

export const Header = ({
  isCardsBoardEmpty,
  setCardsBoard,
  cardsBoard,
  cardsBoardCanDoOpeation,
  hasEditedCards,
  setIsOpenModalPublishChange,
  cardsBoardFiltered,
  cardsClicked,
  setCardsClicked,
}: HeaderProps) => {
  const [openModalPriceCards, setOpenModalPriceCards] = useState(false);
  const game = useSelector(selectGame);

  return (
    <>
      {openModalPriceCards && (
        <ModalChooseStrategy
          setCardsBoard={setCardsBoard}
          cardsBoard={cardsBoard}
          cardsBoardCanDoOpeation={cardsBoardCanDoOpeation}
          setOpen={setOpenModalPriceCards}
        />
      )}
      <FlexBox
        style={{
          width: "100%",
          borderBottom: "1px solid #cbd5e1",
          height: 60,
          alignItems: "center",
          padding: 20,
          backgroundColor: "#f0fdf4",
          gap: 20,
        }}
      >
        <SelectDeselectCards
          cardsBoardFiltered={cardsBoardFiltered}
          setCardsClicked={setCardsClicked}
          cardsClicked={cardsClicked}
        />
        <ImportExportCsv
          cardsBoard={cardsBoard.filter((card) => card.game_id === game.id)}
          setCardsBoard={setCardsBoard}
          cardsClicked={cardsClicked}
          hasImport={false}
        />
        <Box style={{ marginLeft: "auto", display: "flex", gap: 10 }}>
          <PrimaryButton
            disabled={isCardsBoardEmpty}
            isDisabled={isCardsBoardEmpty}
            onClick={() => setOpenModalPriceCards(true)}
          >
            PRICE CARDS
          </PrimaryButton>
          <PrimaryButton
            css={{ marginLeft: "auto" }}
            isDisabled={!hasEditedCards}
            disabled={!hasEditedCards}
            onClick={() => {
              setIsOpenModalPublishChange?.(true);
            }}
          >
            PUBLISH
          </PrimaryButton>
        </Box>
      </FlexBox>
    </>
  );
};
